import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class AssignedPromotionCode<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags Assigned Promotion Code
	 * @name CartSelfAssignedPromotionCodeRemoveB2BPromocodeDelete
	 * @summary Removes promotion codes from the shopping cart.
	 * @request DELETE:/store/{storeId}/cart/@self/assigned_promotion_code/remove_b2b_promocode
	 * @secure
	 * @response `200` `any` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	cartSelfAssignedPromotionCodeRemoveB2BPromocodeDelete = (
		storeId: string,
		query?: {
			/** The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json. */
			responseFormat?: 'xml' | 'json';
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails ||
				this.http.traceDetails['cartSelfAssignedPromotionCodeRemoveB2BPromocodeDelete'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/cart/@self/assigned_promotion_code/remove_b2b_promocode`,
				params: _params,
				query: query,
				methodName: 'cartSelfAssignedPromotionCodeRemoveB2BPromocodeDelete',
			};
			logger.trace(traceData);
		}
		return this.http.request<any, void>({
			path: `/store/${storeId}/cart/@self/assigned_promotion_code/remove_b2b_promocode`,
			method: 'DELETE',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
